<div class="layout-container">
  <mat-toolbar>
    <mat-toolbar-row>
      <div class="title" [routerLink]="['/']">
        <div class="logo"></div>
        <a class="link">Application Event Explorer</a>
      </div>
      <app-menu class="menu"></app-menu>
      <a class="refreshButton" (click)="onRefreshEvent($event)" mat-button>
          <mat-icon>refresh</mat-icon>
          Refresh
      </a>
      <div class="right">{{appName}}</div>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="container">
    <router-outlet></router-outlet>
  </div>

  <app-mat-spinner-overlay *ngIf="displaySpinner" overlay="true"> </app-mat-spinner-overlay>
</div>
